import React from 'react'
import {
  Box,
  Grid,
} from '@material-ui/core'
import { Stack, Checkbox, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { TextField } from './form/TextField'
import { GalleryFormFieldLabel } from './GalleryFormFieldLabel'

export const SessionNameFormField = ({
  control,
  classes,
  setSessionNameVal,
  isEditorForPhotoArt
}) => {

  const labelStyling = {
    width: 130,
    fontWeight: 600,
    fontSize: 12,
    color: '#606060',
    display: 'flex',
    alignItems: 'center'
  }

  const inputStyling = {
    padding: '0px 10px',
    background: '#ebebeb',
    width: 253,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
    color: '#606060'
  }
  // when editing photoArt gallery instance is referred to as a Photo. 
  const sessionNamePlaceholder = isEditorForPhotoArt ? 'Enter Name of Photo' : 'Enter Gallery Name' 

  return (
    <Grid item xs={ 12 }>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <GalleryFormFieldLabel label='Name'/>
        <Typography sx={inputStyling}>
          <Controller
            name='session_name'
            control={control}
            render={(fieldProps, onSessionNameValChanged) => (
              <TextField
                type='text'
                disableUnderline
                variant='standard'
                fieldProps={ fieldProps }
                className={ classes.textField }
                placeholder={ sessionNamePlaceholder }
                onSessionValChanged={setSessionNameVal(
                  fieldProps.field.value,
                )}
                
              />
            )}
          />
        </Typography>
      </Box>
    </Grid>
  )
}
